<template>
  <div class="modal fade" id="payment-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-bs-labelledby="exampleModalCenterTitle" aria-bs-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header d-none">
          <span class="badge badge-soft-success text-uppercase badge font-12px bg-primary-blink text-white">Receive Payment</span>
          <button type="button" class="btn btn-light position-relative p-0 avatar-xs rounded-circle close-modal" data-bs-dismiss="modal" aria-label="Close">
            <span class="avatar-title bg-transparent text-reset font-18px">
              <i class="bx bx-x"></i>
            </span>
          </button>
        </div>

        <div class="modal-body">
          <div class="d-flex justify-content-between align-items-center">
            <span class="badge badge-soft-success text-uppercase badge font-12px bg-primary-blink text-white">Receive Payment</span>
            <button type="button" class="btn btn-light position-relative p-0 avatar-xs rounded-circle pull-right close-modal" data-bs-dismiss="modal" aria-label="Close">
              <span class="avatar-title bg-transparent text-reset font-18px">
                <i class="bx bx-x"></i>
              </span>
            </button>
          </div>

          <div class="payment-panel-parent">
            <!-- Bill Generated Panel -->
            <div v-if="paymentPanel" class="text-center payment-active-panel d-flex flex-column justify-content-around align-items-center sent-success payment-panel">
              <div class="success-image mb-4 pb-4 pt-4">
                <img src="assets/images/bills.svg" height="200" alt="">
              </div>
              <h4 class="text-black fw-bold">{{ message }}</h4>
              <p class="text-muted mb-4">The bill has been created Successfully, you can print the bill or opt to receive payment for this bill.</p>
              <div class="d-flex w-100 pb-2">
                <button @click="$emit('show-payment-method')" type="button" class="btn btn-primary btn-block me-3 flex-grow-1">
                  <i class="mdi-cash-check mdi font-size-16 align-middle me-2"></i>
                  Receive Payment
                </button>
                <a @click="$emit('print-bill')" target="_blank" type="button" class="btn btn-outline-secondary waves-effect dismin-modal">Print Bill</a>
              </div>
            </div>

            <!-- Payment Method Selection -->
            <div v-if="paymentMethod" class="send-method payment-panel">
              <label for="" class="mb-0 pb-0">Payment Method</label>
              <p><small class="text-muted">How would you like to send this money?</small></p>

              <div>
                <div class="accordion" id="accordionExample">
                  <!-- MPESA Payment -->
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button fw-medium" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        <div class="flex-shrink-0 me-3">
                          <img class="rounded-circle" src="assets/images/users/mpesa.jpg" alt="Mobile Money" height="65">
                        </div>
                        <div class="d-flex flex-column">
                          <p class="m-0 p-0 text-uppercase fw-semibold">MPESA</p>
                          <p class="mb-0 p-0"><small>A payment request will be sent directly to the customer</small></p>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        <div>
                          <p>A payment request of <strong class="text-black">KES {{ billDetails.billBalance }}</strong> will be sent to the MPESA number you enter below.</p>
                        </div>
                        <div class="form-group">
                          <label for="">MPESA Number</label>
                          <div class="form-floating mb-3">
                            <input v-model="localPhoneNumber" type="text" class="form-control font-21 text-success form-control-lg" id="phone-input" placeholder="Enter Name">
                            <label for="floatingnameInput">Phone No.</label>
                          </div>
                          <button @click="$emit('show-transaction-summary', 'MPESA')" type="button" class="btn btn-primary btn-block me-3 flex-grow-1">
                            <i class="mdi-cash-check mdi font-size-16 align-middle me-2"></i>
                            Send Payment Request
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Bank Receipting -->
<!--                  <div v-if="getRight('RECEIPT BANK PAYMENT')" class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button fw-medium collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <div class="flex-shrink-0 me-3">
                          <img class="rounded-circle" src="assets/images/users/money.jpg" alt="Mobile Money" height="65">
                        </div>
                        <div class="d-flex flex-column">
                          <p class="m-0 p-0 text-uppercase fw-semibold">bank Receipting</p>
                          <p class="mb-0 p-0"><small>Enter the receipt number here to confirm payment for this transaction.</small></p>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        <div class="form-group">
                          <label for="">Enter The Bank's Receipt Number</label>
                          <div class="form-floating mb-3">
                            <input v-model="localBankReceiptNo" type="text" class="form-control font-21 text-success form-control-lg" id="phone-input" placeholder="Enter Name">
                            <label for="floatingnameInput">Bank Ref No.</label>
                          </div>

                          <div v-if="alert.success" class="alert alert-success" role="alert">
                            {{ message }}
                          </div>

                          <div v-if="alert.info" class="alert alert-primary" role="alert">
                            {{ message }}
                          </div>

                          <div v-if="alert.failed" class="alert alert-danger" role="alert">
                            {{ message }}
                          </div>

                          <button @click="$emit('show-transaction-summary', 'BANK')" class="btn w-100 btn-warning mt-3 btn-bank">
                            Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>-->
                </div>
              </div>
            </div>

            <!-- Transaction Summary -->
            <div v-if="transactionSummary" class="transaction-summary payment-panel">
              <label for="">Transaction Breakdown</label>
              <div class="border p-4 rounded">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="text-muted">BillO NO.</div>
                  </div>
                  <div class="col-lg-6 align-self-end">
                    <div class="text-right text-black">{{ billDetails.billNo }}</div>
                  </div>

                  <div class="col-lg-6">
                    <div class="text-muted mt-2">Bill For</div>
                  </div>
                  <div class="col-lg-6 align-self-end">
                    <div class="text-right text-black">{{ billDetails.incomeTypeDescription }}</div>
                  </div>

                  <div class="col-lg-6">
                    <div class="text-muted mt-2">Payment Method</div>
                  </div>
                  <div class="col-lg-6 align-self-end">
                    <div class="text-right text-black">{{ paymentData.paymentMode }}</div>
                  </div>

                  <div class="col-lg-6">
                    <div class="text-muted mt-2">Transaction Amount</div>
                  </div>
                  <div class="col-lg-6 align-self-end">
                    <div class="text-right text-black">KES {{ billDetails.billBalance }}</div>
                  </div>

                  <div class="col-12 text-black"><hr class="mb-0 pb-0"></div>

                  <div class="col-lg-6 text-uppercase">
                    <div class="text-muted mt-2 font-21">Total</div>
                  </div>
                  <div class="col-lg-6 align-self-end text-uppercase">
                    <div class="text-right text-black font-21 fw-bold">KES {{ billDetails.billBalance }}</div>
                  </div>
                </div>

                <div class="mpesa-confirmation">
                  <div v-if="paymentData.paymentMode === 'MPESA'">
                    <p class="text-muted mt-2">A payment request of <strong class="text-black">KES {{ billDetails.billBalance }}</strong> will be sent to <strong class="text-black">{{ phoneNumber || localPhoneNumber }}</strong> soon after you click the <strong class="text-black text-capitalize">Send Request</strong> button bellow.
                      <br><br>
                      Remember to <strong class="text-black">Check your phone</strong> to confirm payment by entering your Mpesa pin.</p>
                  </div>

                  <div>{{ message }}</div>
                  <br>
                  <button @click="$emit('make-payment')" class="btn btn-primary btn-flex flex-grow-1 waves-effect btn-send waves-light text-center w-100">
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="stk-timer-container d-none justify-content-center align-items-center">
                        <span class="mdi mdi-timer-outline font-16px"></span>
                        <span class="stk-timer px-2"></span>
                      </div>
                      <div class="justify-content-center align-items-center d-flex">
                        <span class="px-2">Send Request</span>
                        <div class="flip-x"><i class="mdi mdi-reply ms-3 font-16px"></i></div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>

            <!-- Transaction Completed -->
            <div v-if="transactionCompleted" class="text-center d-flex flex-column justify-content-around align-items-center sent-success payment-panel">
              <div class="success-image mb-4">
                <img src="assets/images/payment-confirmation-images/sent.svg" height="200" alt="">
              </div>
              <h4 class="text-blink-primary fw-bold">Transaction Complete</h4>
              <p class="text-muted mb-4"><strong class="text-black">KES {{ receiptDetails.receiptAmount }}</strong> has been received for <strong class="text-black">Bill No. {{ receiptDetails.billNo }}</strong></p>
              <button @click="$emit('print-receipt')" type="button" class="btn btn-primary btn-block me-3 flex-grow-1">
                <i class="mdi-cash-check mdi font-size-16 align-middle me-2"></i>
                Print Receipt
              </button>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex d-none bill-modal-footer">
          <button href="javascript: void(0);" disabled class="btn btn-outline-light waves-effect waves-light payment-prev">
            <i class="mdi mdi-arrow-left ms-1"></i>Previouse
          </button>
          <button href="javascript: void(0);" class="btn btn-primary waves-effect waves-light payment-next">
            Next <i class="mdi mdi-arrow-right ms-1"></i>
          </button>
          <button href="javascript: void(0);" class="btn btn-primary btn-flex flex-grow-1 waves-effect waves-light text-center d-none">
            <div class="d-flex justify-content-center align-items-center">
              <span>Send Money</span>
              <div class="flip-x"><i class="mdi mdi-reply flip-x ms-3 font-16px"></i></div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentModal',

  props: {
    message: {
      type: String,
      default: null
    },
    paymentPanel: {
      type: Boolean,
      default: true
    },
    paymentMethod: {
      type: Boolean,
      default: false
    },
    transactionSummary: {
      type: Boolean,
      default: false
    },
    transactionCompleted: {
      type: Boolean,
      default: false
    },
    phoneNumber: {
      type: String,
      default: ''
    },
    billDetails: {
      type: Object,
      default: () => ({
        billNo: '',
        billBalance: 0,
        incomeTypeDescription: ''
      })
    },
    paymentData: {
      type: Object,
      default: () => ({
        bankReceiptNo: null,
        paymentMode: null
      })
    },
    receiptDetails: {
      type: Object,
      default: () => ({
        receiptAmount: 0,
        billNo: ''
      })
    },
    alert: {
      type: Object,
      default: () => ({
        success: false,
        info: false,
        failed: false
      })
    }
  },

  data() {
    return {
      localPhoneNumber: this.phoneNumber,
      localBankReceiptNo: this.paymentData.bankReceiptNo
    }
  },

  watch: {
    phoneNumber(newVal) {
      this.localPhoneNumber = newVal
    },
    'paymentData.bankReceiptNo'(newVal) {
      this.localBankReceiptNo = newVal
    },
    localPhoneNumber(newVal) {
      this.$emit('update:phoneNumber', newVal)
    },
    localBankReceiptNo(newVal) {
      this.$emit('update:bankReceiptNo', newVal)
    }
  }
}
</script>